<template>
    <label :for="inputId" class="form-label">{{labelText}}</label>

    <input :type="textMode" class="form-control" :id="inputId" v-model="myModel" @input="update" @blur="this.$emit('blur')" :disabled="disabled == 1" />
    
    <div class="errorMessageForm" v-for="error of myErrors" :key="error.$uid">
        {{error.$message}}
    </div>

</template>
  
<script>
export default {
    name: "TextInput",
    props: {
        inputId:String,
        labelText:String,
        inputVModel: {},
        objectKey:String,
        myErrors:[],
        disabled:Number,
        textMode:{
            type:String, 
            default:"text",
        }
    },
    data() {
        return {
            myModel:''
        };
    },
    mounted(){
        this.myModel = this.inputVModel; 
        //console.log("my model: ",this.myModel);
    },
    methods:{
        update(){
            this.$emit("UpdateForm", this.objectKey, this.myModel);
        }
    },
    watch:{
        inputVModel(newVal,oldVal){
            //console.log("old value: ", oldVal, "new value: ", newVal);
            oldVal;
            this.myModel = newVal;
        }
    },
};
</script>
  